import { Injectable } from '@angular/core';

import { setInitialStoreState } from '../../../../../common/utils';
import { UserDataChangesListFacade } from './user-data-changes-list.facade';

@Injectable({
  providedIn: 'root',
})
export class UserDataChangesListGuard  {
  constructor(private userDataChangesListFacade: UserDataChangesListFacade) {}

  canDeactivate(): boolean {
    return setInitialStoreState(this.userDataChangesListFacade);
  }
}
